<template>
  <b-modal ref="deletion-modal" :size="modalSize" no-close-on-backdrop no-close-on-esc>
    <template #modal-header>
      <h5>{{ headerMessage ? headerMessage : 'Bitte bestätigen Sie diese Entscheidung.' }}</h5>
    </template>
    <b-container>{{ subheaderMessage ? subheaderMessage : 'Wirklich löschen?' }}</b-container>
    <template #modal-footer>
      <b-button @click="$emit('deleteConfirm')" variant="outline-danger">
        {{ confirmButtonLabel ? confirmButtonLabel : "Löschen" }} <b-icon-trash/>
      </b-button>
      <b-button @click="$emit('close')" variant="outline-secondary">
        {{ abortButtonLabel ? abortButtonLabel : "Eintrag behalten" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "DeletionModal",
  props: {
    subheaderMessage: String,
    headerMessage: String,
    abortButtonLabel: String,
    confirmButtonLabel: String,
    show: Boolean,
    modalSize: String
  },
  emits: {
    close: null,
    deleteConfirm: null
  },
  mounted() {
    if (this.show) {
      this.$refs["deletion-modal"].show()
    } else {
      this.$refs["deletion-modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["deletion-modal"].toggle()
    }
  }
}

</script>

<style scoped>

</style>